<template>
    <ModalBase :name="name" :title="title" :subtitle="subtitle">
        <div class="tw:text-gray-700">
            <slot>
                <p class="tw:text-base">¿Está seguro de que desea eliminar este elemento?</p>
            </slot>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="handleCancel">Cancelar</Button>
                <Button variant="danger" data-cy="confirmar-eliminar" @click="handleConfirm">Eliminar</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { getCurrentInstance } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        }
    })

    const emit = defineEmits(['confirm', 'cancel', 'close'])
    const { proxy } = getCurrentInstance();

    const handleCancel = () => {
        emit('cancel')
        proxy.$modal.hide(props.name)
        emit('close')
    }

    const handleConfirm = () => {
        emit('confirm')
        proxy.$modal.hide(props.name)
        emit('close')
    }
</script>
